import wacType from '../type/wac';

export default () => `
    wacs {
        ${wacType()}
    }
`;
